import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { P2GGrid, P2GRadio, P2GText } from '@parcel2go/core-ui';
import { SenderTypeOptions, SenderTypesConst } from './sender-type-types';
import P2GOptionContainer from '~/components/core/option/option';

type SenderTypeProps = {
  onSelect: (type: SenderTypeOptions) => void;
  value: string | undefined | null;
  errors?: Record<string, string>;
};

const radioGroup = 'sender-type';

export default function SenderType({ errors, value, onSelect }: SenderTypeProps) {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  return (
    <P2GGrid container spacing={2} dataTestId="sender-type-radio-buttons">
      <P2GGrid item xs={12}>
        <P2GText>
          <Trans t={t} key="SENDER-TYPE-MESSAGE">
            This information helps us to provide you with relevant rates and services in the future.
          </Trans>
        </P2GText>
      </P2GGrid>
      <P2GGrid item xs={12} md={6}>
        <P2GOptionContainer
          selected={value === SenderTypesConst.Personal}
          variant="sender-type"
          onClick={() => onSelect(SenderTypesConst.Personal)}
        >
          <P2GRadio
            checked={value === SenderTypesConst.Personal}
            id="personal"
            name={radioGroup}
            value="personal"
            label={t('SENDER_TYPE_PERSONAL', { defaultValue: 'Personal Use' })}
            dataTestId="personal-sender-type"
            radioGroup={radioGroup}
            variant="primary"
            required
          />
        </P2GOptionContainer>
      </P2GGrid>
      <P2GGrid item xs={12} md={6}>
        <P2GOptionContainer
          variant="sender-type"
          selected={value === SenderTypesConst.Business}
          onClick={() => onSelect(SenderTypesConst.Business)}
        >
          <P2GRadio
            dataTestId="business-sender-type"
            radioGroup={radioGroup}
            checked={value === SenderTypesConst.Business}
            id="business"
            name={radioGroup}
            value="business"
            label={t('SENDER_TYPE_BUSINESS', { defaultValue: 'Business Use' })}
            variant="primary"
            required
          />
        </P2GOptionContainer>
      </P2GGrid>
      {errors && errors[radioGroup] && (
        <P2GGrid item xs={12}>
          <P2GText color="error" fontWeight={700}>
            {errors[radioGroup]}
          </P2GText>
        </P2GGrid>
      )}
    </P2GGrid>
  );
}
